const CLIPBOARD = {
	install (Vue, options) {
		Vue.prototype.$grv_clipboard = {

			copyToClipboard (value) {
				let text = ''
				if (typeof (value) === 'string') {
					text = value
				} else if (Array.isArray(value)) {
					text = value.join('\n')
				} else if (value instanceof Object) {
					try {
						text = JSON.stringify(text)
					} catch (error) {
						return false
					}
				}
				if (text !== '') {
					const el = document.createElement('textarea')
					el.addEventListener('focusin', e => e.stopPropagation())
					el.value = text
					document.body.appendChild(el)
					el.select()
					document.execCommand('copy')
					document.body.removeChild(el)
					return true
				}
				return false
			},

			copyPrestaInfos (jr_id) {
				let html = `<a
					href=prestation/${jr_id}
					style="background-color: white; color: #000056"
					target="_blank">
					[Prestation #${jr_id}]
				</a>`
				let container = document.createElement('div')
				container.innerHTML = window.vm.$sanitize(html)
				container.style.position = 'fixed'
				container.style.pointerEvents = 'none'
				container.style.opacity = 0
				document.body.appendChild(container)
				window.getSelection().removeAllRanges()
				let range = document.createRange()
				range.selectNode(container)
				window.getSelection().addRange(range)
				document.execCommand('copy')
				document.body.removeChild(container)
				window.vm.$EventDialer(
					'success',
					false,
					'Copié dans le presse-papier',
					`Prestation #${jr_id}`,
					2000
				)
			},

			copyMultiPrestaInfos (jrs) {
				let html = ''
				for (const jr of jrs) {
					html += `<a
						href=prestation/${jr.id}
						style="background-color: white; color: #000056"
						target="_blank">
						[Prestation #${jr.id}]
					</a>`
				}
				let container = document.createElement('div')
				container.innerHTML = window.vm.$sanitize(html)
				container.style.position = 'fixed'
				container.style.pointerEvents = 'none'
				container.style.opacity = 0
				document.body.appendChild(container)
				window.getSelection().removeAllRanges()
				let range = document.createRange()
				range.selectNode(container)
				window.getSelection().addRange(range)
				document.execCommand('copy')
				document.body.removeChild(container)
				let message = jrs.map(jr => `Prestation #${jr.id}`)
				window.vm.$EventDialer(
					'success',
					false,
					'Copié dans le presse-papier',
					message,
					2000
				)
			}

		}
	}
}

export default CLIPBOARD



// WEBPACK FOOTER //
// ./src/plugins/clipboard.js